<template>
    <div class="text-black">

        <slot><p class="text-grey">Select one or more options to get started</p></slot>

        <div class="">
            <div class="relative py-2">
                <div class="absolute pin-y pin-l pl-3 flex items-center text-grey">
                    <i class="fa fa-search"></i>
                </div>
                <input
                        v-model="search"
                        type="search"
                        class="p-2 pl-8 rounded bg-grey-lighter w-full"
                        aria-label="Search in Indicator"
                        v-bind:placeholder="placeholder"
                >
                <div v-show="search" v-on:click="clearSearch()"
                     class="absolute pin-y pin-r pr-3 flex items-center text-red">
                    <i class="fa fa-remove"></i>
                </div>
            </div>
        </div>

        <div class="border-l border-r border-b mt-4 text-sm">
            <div class="" v-show="loading"><i class="fa fa-circle-o-notch fa-spin"></i></div>
            <div
                    class=""
                    v-if="search && !loading && result.length === 0"
            >
                We didn't find any results for "{{ search }}". Sorry!
            </div>

            <dsi-folder
                    v-show="search"
                    v-for="item in searchFolders"
                    :key="item.id"
                    :item="item"
                    :search="search"
                    :depth="0"
            ></dsi-folder>
            <dsi-code
                    v-show="search"
                    v-for="item in searchCodes"
                    :key="item.id"
                    :item="item"
                    :search="search"
                    :depth="0"
            >
            </dsi-code>

            <dsi-folder
                    v-show="!search"
                    v-for="item in sortFolders"
                    :key="item.id"
                    :item="item"
                    :search="search"
                    :depth="0"
            >
            </dsi-folder>
            <dsi-code
                    v-for="item in sortCodes"
                    :key="item.id"
                    v-show="!search"
                    :item="item"
                    :search="search"
                    :depth="0"
            >
            </dsi-code>
        </div>


    </div>

</template>

<script>

    export default {

        props: {
            'item': Object,
            'multiple': {
                type: Boolean,
                default: true,
            }
        },

        mounted: function () {
            this.openFolder(this.item);
        },

        watch: {
            search: 'doSearch',
        },

        data: function () {
            return {
                storage: storage,
                selected: [],
                search: '',
                result: [],
                folders: [],
                codes: [],
                loading: false,
                availability: [],
            };
        },

        computed: {
            placeholder: function () {
                return 'Search';
            },
            searchFolders: function () {
                return _.sortBy(this.result.folders, 'translations.en');
            },
            searchCodes: function () {
                return _.sortBy(this.result.codes, 'translations.en');
            },
            sortFolders: function () {
                return _.sortBy(this.folders, 'translations.en');
            },
            sortCodes: function () {
                return _.sortBy(this.codes, 'translations.en');
            }
        },

        methods: {
            isAvailable: function (item) {
                return this.isDisabledCode(this.item.id, item);
            },

            doSearch: function () {

                // always delete old results
                this.result = [];

                if (this.search === '') {
                    this.loading = false;

                    return;
                }

                this.loading = true;

                window.http
                    .get(
                        '/api/v1/indicators/' + this.storage.database + '/dimensions/' + this.item.id + '/treeSearch/' + this.search
                    )
                    .then((response) => {
                        // it can happen that a user types "gr"
                        // the response for "gr" comes back immediately and is empty
                        // but the response for "g" is valid.
                        if (response.data.query !== this.search) {
                            return; // just ignore the response!
                        }
                        this.result = response.data.tree;
                        this.loading = false;
                    })
                    .catch((error) => {
                        /*if (response.data.query !== this.search) {
                            return; // just ignore the response!
                        }*/
                        this.loading = false;
                        this.result = [];
                    });
            },

            openFolder: function (item) {
                this.loading = true;

                window.http
                    .get(
                        '/api/v1/indicators/' + this.storage.database + '/dimensions/' + item.id
                    )
                    .then((response) => {
                        this.folders = response.data.folders;
                        this.codes = response.data.codes;
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.loading = false;
                    });
            },

            clearSearch: function () {
                this.search = '';
            },
        },

    }

</script>
